import { trackEvent } from './config'

export type UpgradePrompt = 'patient_limit' | 'payment_soon' | 'account_closed' | 'trial_expired' | 'payment_due' | 'upgrade'

export type UpgradeSurface = 'patients' | 'calendar' | 'clinical_record' | 'navbar'

type AccountSnapshot = { account_state: 'open' | 'soon' | 'closed'; account_type?: 'freemium' | 'paid' }

/** Names the paywall banner an account state calls for, or null when the account is in good standing. */
export function getAccountPrompt(healthCenter: AccountSnapshot): UpgradePrompt | null {
  if (healthCenter.account_state === 'closed') {
    return 'account_closed'
  }
  if (healthCenter.account_state !== 'soon') {
    return null
  }
  if (healthCenter.account_type === 'freemium') {
    return 'patient_limit'
  }
  return 'payment_soon'
}

/** Builds the click handler for a prompt's link, sent as a beacon because the link leaves the SPA. */
export function trackUpgradePromptClick(prompt: UpgradePrompt, surface: UpgradeSurface) {
  return () => trackEvent('Upgrade Prompt Clicked', { prompt, surface }, { transport: 'sendBeacon' })
}
